
const EstilosGlobales = {
    colorPrimario:"#ff6400",
    colorPrimarioContrast:"#ffe7d8",
    colorSecundario:"#1a1919",    
}

export default EstilosGlobales;
